import * as shared from 'UIShared';

export function getFont(font: keyof shared.THEME_FONTS) {
  return `var(${shared.FONT_PREFIX}${font})`;
}
